import React from "react";
import { ChevronRight, Code, Pencil, ArrowClockwise } from "react-bootstrap-icons";
import { Link as LinkIcon } from "react-bootstrap-icons";
import * as Styled from "./ProfileCard.styled";

export interface ProfileCardProps {
  title: string;
  subtitle: string;
  isLinked: boolean | undefined;
  isEnabled: boolean;
  onEdit: () => void;
  onChevronRightClick: () => void;
  onToggleEnabled: (enabled: boolean) => void;
  onEmbedCode?: () => void;
  onInvalidateCache?: () => void;
}

export const ProfileCard: React.FC<ProfileCardProps> = ({
  title,
  subtitle,
  isLinked,
  isEnabled,
  onEdit,
  onChevronRightClick,
  onToggleEnabled,
  onEmbedCode,
  onInvalidateCache,
}) => {
  const handleCardClick = (e: React.MouseEvent) => {
    // Only trigger edit if not clicking on controls
    if (!(e.target as HTMLElement).closest('[data-no-propagate]')) {
      onChevronRightClick();
    }
  };

  return (
    <Styled.StyledCard onClick={handleCardClick}>
      <Styled.LeftSection>
        <Styled.Title>{title}</Styled.Title>
        <Styled.Subtitle>{subtitle}</Styled.Subtitle>
      </Styled.LeftSection>

      <Styled.RightSection>
        {isLinked !== undefined && <Styled.LinkStatusIcon $isLinked={isLinked}>
          <LinkIcon />
        </Styled.LinkStatusIcon>}

        <Styled.EditIcon data-no-propagate onClick={(e) => { e.stopPropagation(); onEdit(); }} title="Edit">
          <Pencil />
        </Styled.EditIcon>

        {onEmbedCode && (
          <Styled.EditIcon data-no-propagate onClick={(e) => { e.stopPropagation(); onEmbedCode(); }} title="Get embed code">
            <Code />
          </Styled.EditIcon>
        )}

        {onInvalidateCache && (
          <Styled.EditIcon data-no-propagate onClick={(e) => { e.stopPropagation(); onInvalidateCache(); }} title="Invalidate cache">
            <ArrowClockwise />
          </Styled.EditIcon>
        )}

        <Styled.ControlsWrapper data-no-propagate onClick={(e) => e.stopPropagation()}>
          <Styled.ControlIndicator $isEnabled={isEnabled} />
          <Styled.ControlButton
            $isActive={!isEnabled}
            onClick={() => onToggleEnabled(false)}
            title="Disable"
          >
            ✕
          </Styled.ControlButton>
          <Styled.ControlButton
            $isActive={isEnabled}
            onClick={() => onToggleEnabled(true)}
            title="Enable"
          >
            ✓
          </Styled.ControlButton>
        </Styled.ControlsWrapper>

        <Styled.Circle>
          <ChevronRight />
        </Styled.Circle>
      </Styled.RightSection>
    </Styled.StyledCard>
  );
};
